<template>
    <div>
        <div class="modal hide fade" id="modalGetVariantList" tabindex="-1" role="dialog" aria-labelledby="modalGetVariantList" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Variant List</h4>
                        <span>{{ state }}</span>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group row">
                                  <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                                  <div class="col-sm-9">
                                    <input class="form-control" type="text" id="name" v-model="vList.name"/>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label for="variant_id" class="col-sm-3 col-form-label text-left">Variant</label>
                                  <div class="col-sm-9">
                                    <select v-model="vList.variant_id" class="form-control" @change="setVar">
                                      <option v-for="v in variantList" :key="v.id" :value="v.id">{{ v.name }}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label for="qty" class="col-sm-3 col-form-label text-left">Quantity</label>
                                  <div class="col-sm-9">
                                    <input class="form-control" type="number" id="qty" v-model="vList.qty"/>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label for="uom_id" class="col-sm-3 col-form-label text-left">UoM</label>
                                  <div class="col-sm-9">
                                    <select v-model="vList.uom_id" class="form-control">
                                      <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label for="price" class="col-sm-3 col-form-label text-left">Price</label>
                                  <div class="col-sm-9">
                                    <input class="form-control" type="number" id="price" v-model="vList.price"/>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group row">
                                  <label for="warehouse_no" class="col-sm-3 col-form-label text-left">Warehouse</label>
                                  <div class="col-sm-9">
                                    <select v-model="vList.warehouse_no" class="form-control" @change="setWarehouse">
                                      <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no">[{{ w.warehouse_no }}] {{ w.name }}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label for="on_hand_date" class="col-sm-3 col-form-label text-left">Date</label>
                                  <div class="col-sm-9">
                                    <datetime v-model="vList.on_hand_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label for="notes" class="col-sm-3 col-form-label text-left">Notes</label>
                                  <div class="col-sm-9">
                                    <textarea class="form-control" name="notes" v-model="vList.notes" rows="7"></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-hard-primary" data-dismiss="modal" @click="cancel()">Cancel</button>
                      <button type="button" class="btn btn-soft-primary" data-dismiss="modal" @click="save()">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductModalVariant',
  props: ['product', 'id', 'state'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      variantList: state => state.variants.variantList,
      warehouseList: state => state.warehouses.warehouseList,
      uomList: state => state.uom.uomList
    }),
    vList: function () {
      var obj
      var index = this.product.variants.find(d => d.id === this.id)
      if (index) {
        return index
      } else {
        obj = {
          id: null,
          product_no: null,
          product_sku: null,
          name: null,
          variant_id: null,
          variant: null,
          uom_id: 'pcs',
          qty: 0,
          warehouse_no: null,
          warehouse: null,
          branch_no: null,
          serial_number: null,
          price: 0
        }
        return obj
      }
    }
  },
  methods: {
    save () {
      if (this.product.variants) {
        var v = this.product.variants.find(d => d.id === this.id)
        v.state = this.state
        v.product_no = this.product.product_no
        console.log(v)
      }
    },
    cancel () {
      if (this.state === 'create') {
        var index = this.product.variants.findIndex(d => d.id === this.id)
        this.product.variants.splice(index, 1)
      }
    },
    setVar () {
      var v = this.vList.variant_id
      var vl = this.variantList.filter(l => l.id === v)
      this.vList.variant = vl[0].name
      console.log(this.vList)
    },
    setWarehouse () {
      var w = this.vList.warehouse_no
      var wl = this.warehouseList.filter(l => l.warehouse_no === w)
      this.vList.warehouse = wl[0].name
      console.log(this.wList)
    }
  }
}
</script>
